import Card from './card.vue';

export { Card };
export default Card;
